import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  IconButton,
  Tooltip,
  Stack,
  Chip,
  useTheme,
} from "@mui/material";
import { OpenInFull, Preview } from "@mui/icons-material";
import Editor from "../../Editor";

function RichTextEditorCard({ value, onChange, onExpand }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  // Calculate word count
  const wordCount = value
    ? value.replace(/<[^>]*>/g, " ").trim().split(/\s+/).filter((w) => w.length > 0).length
    : 0;

  return (
    <Box sx={{ mb: 3 }}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 1.5 }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="subtitle1" fontWeight={600}>
            Content (Rich Text)
          </Typography>
          {wordCount > 0 && (
            <Chip
              label={`${wordCount} words`}
              size="small"
              variant="outlined"
              sx={{ fontSize: "0.7rem", height: "24px" }}
            />
          )}
        </Stack>
        <Stack direction="row" spacing={0.5}>
          <Tooltip title="Open in Full Editor">
            <IconButton
              onClick={onExpand}
              size="small"
              sx={{
                color: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)",
                },
              }}
            >
              <OpenInFull fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
      <Card
        variant="outlined"
        sx={{
          borderRadius: "12px",
          border: `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`,
          backgroundColor: isDark ? "rgba(255,255,255,0.02)" : "#ffffff",
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
          <Editor value={value} onChange={onChange} placeholder="Start writing your content here..." />
        </CardContent>
      </Card>
    </Box>
  );
}

export default RichTextEditorCard;
